import { render, staticRenderFns } from "./MobilePrdtsFilter.vue?vue&type=template&id=5059a20d&"
import script from "./MobilePrdtsFilter.vue?vue&type=script&lang=js&"
export * from "./MobilePrdtsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports